import {
  useEffect,
  useMemo,
  useState
} from 'react';
import type { Router } from '@toolpad/core/AppProvider';

export function useDemoRouter(initialPath?: string): Router {
  const [pathname, setPathname] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.location.pathname;
    }
    return initialPath ?? '/dashboard';
  });

  useEffect(() => {
    const onPopState = () => {
      setPathname(window.location.pathname);
    };

    window.addEventListener('popstate', onPopState);

    return () => window.removeEventListener('popstate', onPopState);
  }, []);

  const router = useMemo(() => {
    return {
      pathname,
      searchParams: new URLSearchParams(window.location.search),
      navigate: (path: string | URL) => {
        let newPath = typeof path === 'string' ? path : path.toString();

        if (newPath !== pathname) {
          window.history.pushState(null, '', newPath);
          setPathname(newPath);
        }
      },
    };
  }, [pathname]);

  return router;
}